import React from "react";
import { makeStyles, Box } from "@material-ui/core";
import Theme from "../.themes/common/Theme";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => ({
  customWidthBox: (props: CompositionBoxProps) => ({
    // due to padding below, we need to increase max width, as padding will decrease space available for content
    maxWidth:
      props.maxWidth === undefined
        ? theme.compositionBoxWidth
          ? theme.compositionBoxWidth + theme.spacing(4)
          : undefined
        : props.maxWidth
        ? props.maxWidth + theme.spacing(4)
        : undefined,
    width: "100%",
    boxSizing: "border-box",
    // this fixes box positioning broken by PR 23113
    // works well with both Polestar and IMF
    margin: theme.centred ?? `${theme.spacing(2)}px 0`,
    padding: `0 ${theme.spacing(2)}px`,
    marginTop: props.marginTop,
  }),
}));

type CompositionBoxProps = {
  children: React.ReactNode | React.ReactNode[];
  maxWidth?: number;
  marginTop?: number;
  className?: string;
};

const CompositionBox: React.FC<CompositionBoxProps> = (props: CompositionBoxProps) => {
  const css = useStyles(props);

  return (
    <Box className={clsx(css.customWidthBox, props.className)}>
      {props.children}
    </Box>
  );
};

export default CompositionBox;
